import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FAIRE_EMPLOYEE_GROUPS } from "@faire/retailer-visitor-shared/views/careers/__internal__/BelongingAtFaire/faireEmployeeGroups";
import { EyebrowText, LimitedSectionContent, Section } from "@faire/retailer-visitor-shared/views/careers/__internal__/common/common";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var BelongingEmployeeCommunities = function() {
    var headlineSpace = useResponsiveValue({
        mobileAndAbove: "7x",
        tabletAndAbove: "10x"
    });
    return /*#__PURE__*/ _jsx(Section, {
        $withHorizontalPadding: true,
        $withVerticalPadding: true,
        align: "center",
        children: /*#__PURE__*/ _jsxs(LimitedSectionContent, {
            children: [
                /*#__PURE__*/ _jsx(EyebrowText, {
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "J6flA/",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Our employee communities"
                            }
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "3x"
                }),
                /*#__PURE__*/ _jsx(MaxWidthTypography, {
                    variant: {
                        mobileAndAbove: "displaySSerifRegular",
                        tabletAndAbove: "displayMSerifRegular"
                    },
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "E5s7Uu",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Meet our employee-led resource groups, open to all Faire employees."
                            }
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: headlineSpace
                }),
                /*#__PURE__*/ _jsx(GridComponent, {})
            ]
        })
    });
};
var GridComponent = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var numRowsDesktopAndAbove = Math.ceil(FAIRE_EMPLOYEE_GROUPS(strictLocalize).length / 2);
    return /*#__PURE__*/ _jsx(Grid, {
        $numRowsDesktopAndAbove: numRowsDesktopAndAbove,
        children: FAIRE_EMPLOYEE_GROUPS(strictLocalize).map(function(group) {
            return /*#__PURE__*/ _jsx(React.Fragment, {
                children: /*#__PURE__*/ _jsx(CellComponent, {
                    title: group.title,
                    description: group.description
                })
            }, group.title);
        })
    });
};
var CellComponent = function(param) {
    var title = param.title, description = param.description;
    return /*#__PURE__*/ _jsxs(Column, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: {
                    mobileAndAbove: "subheadingSansMedium",
                    tabletAndAbove: "displaySSansRegular"
                },
                children: title
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "1x"
            }),
            /*#__PURE__*/ _jsx(CellDescription, {
                variant: {
                    mobileAndAbove: "paragraphSansRegular",
                    tabletAndAbove: "subheadingSansRegular"
                },
                children: description
            })
        ]
    });
};
var MaxWidthTypography = styled(Typography).withConfig({
    componentId: "sc-1ea8eecd-0"
})([
    "max-width:",
    ";"
], getSpacing(430));
var Grid = styled.div.withConfig({
    componentId: "sc-1ea8eecd-1"
})([
    "display:grid;column-gap:",
    ";row-gap:",
    ";",
    "{grid-template-rows:repeat( ",
    ",auto );grid-auto-flow:column;row-gap:",
    ";margin-left:auto;}"
], getSpacing("9x"), getSpacing("4x"), responsiveMediaQueries.desktopAndAbove, function(props) {
    return props.$numRowsDesktopAndAbove;
}, getSpacing("5x"));
var CellDescription = styled(Typography).withConfig({
    componentId: "sc-1ea8eecd-2"
})([
    "max-width:",
    ";",
    "{max-width:",
    ";}"
], getSpacing(368), responsiveMediaQueries.tabletAndBelow, getSpacing(470));
